enum Constants {
  InitConfig,
  SetCategories,
  SetUserInfo,
  SetIm
}

const constants = Constants
export default constants
